import {defineStore} from 'pinia';

export const useGeneralStore = defineStore('general', {
    state: function () {

        return {
            /**
             * Expected values: false|listening|notListening|exitListening
             */
            beforeunloadListenerTracker: false
        };

    },

});
